// ─── Pre-account step IDs ───────────────────────────────────────────────

const BackendTrackedSteps = {
  InitOnboarding: 'initOnboarding',
  ExpensesDescription: 'expensesDescription',
  AbIbanOnInvoices: 'abIbanOnInvoices',
  TaxesDescription: 'taxesDescription',
  Advantages: 'advantages',
  Notifications: 'notifications',
  PersonalDetails: 'personalDetails',
  UploadDocument: 'uploadDocument',
  BornDetails: 'bornDetails',
  ResidencyDetails: 'residencyDetails',
  KycStarted: 'kycStarted',
  KycCompleted: 'kycCompleted',
} as const;

const LocalOnlySteps = {
  PeppolBanking: 'peppol_banking',
  SummaryDetails: 'pre_account_summary_details',
  SummaryRegistration: 'pre_account_summary_registration',
  SummaryIdentification: 'pre_account_summary_identification',
  PersonalInfoForm: 'personal_info_form',
  BusinessAddressForm: 'business_address_form',
  BusinessActivityForm: 'business_activity_form',
  BEBusinessActivityForm: 'be_business_activity_form',
  BEBusinessAddressForm: 'be_business_address_form',
  ProofOfRegistrationUploader: 'proof_of_registration_uploader',
  BornDetailsForm: 'born_details_form',
  ResidencyDetailsForm: 'residency_details_form',
  ConfirmIdentity: 'confirm_identity',
} as const;

export const PreAccountStepId = {
  ...BackendTrackedSteps,
  ...LocalOnlySteps,
} as const;

// ─── Types ──────────────────────────────────────────────────────────────

export type SwanOnboardingStepIdType =
  typeof BackendTrackedSteps[keyof typeof BackendTrackedSteps];

type PreAccountStepIdType =
  typeof PreAccountStepId[keyof typeof PreAccountStepId];
